// extracted by mini-css-extract-plugin
export default {"questions":"Questions_questions__dL7wG"};